/**
 * Logger utility - Only logs in development mode
 * Provides console.log wrapper that automatically checks environment
 */

import { ENV } from "@/config/env";

export const logger = {
  log: (...args: unknown[]) => {
    if (ENV.IS_DEVELOPMENT) {
      console.log(...args);
    }
  },

  error: (...args: unknown[]) => {
    if (ENV.IS_DEVELOPMENT) {
      console.error(...args);
    }
  },

  warn: (...args: unknown[]) => {
    if (ENV.IS_DEVELOPMENT) {
      console.warn(...args);
    }
  },

  info: (...args: unknown[]) => {
    if (ENV.IS_DEVELOPMENT) {
      console.info(...args);
    }
  },

  debug: (...args: unknown[]) => {
    if (ENV.IS_DEVELOPMENT) {
      console.debug(...args);
    }
  },
} as const;
